// extracted by css-extract-rspack-plugin
export default {"summaryContainer":"SubIssuesSummary-module__summaryContainer__J8S6s"};